<template>
  <div id="app">
    <b-container id="container">
      <PageRangeAnalyzer />
    </b-container>
  </div>
</template>

<script>
import PageRangeAnalyzer from "./components/PageRangeAnalyzer.vue";

export default {
  name: "App",
  components: {
    PageRangeAnalyzer,
  },
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap.scss";

.noselect {
  webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
